"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var EditFieldMaker_1 = __importDefault(require("containers/TableMaker/components/EditFieldMaker"));
var makeAddressEditField = function (field) { return (0, EditFieldMaker_1.default)({
    collection: 'recharged_customers',
    setter: function (value) {
        var _a;
        return ({ address: (_a = {}, _a[field] = value, _a) });
    },
    getter: function (item) { var _a, _b; return (_b = (_a = item.rechCustomer) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b[field]; },
    idGetter: function (item) { return item.rechCustomerId; },
    noEditCondition: function (item) { var _a, _b; return (_b = (_a = item.rechCustomer) === null || _a === void 0 ? void 0 : _a.crawledMigrationCustomer) === null || _b === void 0 ? void 0 : _b.confirmedOn; },
    disableCondition: function (item) { var _a, _b; return !item.rechCustomerId || !!((_b = (_a = item.rechCustomer) === null || _a === void 0 ? void 0 : _a.crawledMigrationCustomer) === null || _b === void 0 ? void 0 : _b.confirmedOn); },
}); };
exports.default = makeAddressEditField;
